import type { NotificationConfig } from '../notifications';

export function makeAuthHeaders(token: string): { Authorization: string } {
  return {
    Authorization: `Bearer ${token}`,
  };
}

/** Request config with the bearer header and, optionally, the notification override the interceptors read. */
export function makeAuthConfig(token: string, notification?: NotificationConfig) {
  const headers = makeAuthHeaders(token);
  return notification ? { headers, notification } : { headers };
}
